export default "__VITE_ASSET__CIrSyrDE__"